var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgInfoCircle = function SvgInfoCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0.875C4.11758 0.875 1.375 3.61758 1.375 7C1.375 10.3824 4.11758 13.125 7.5 13.125C10.8824 13.125 13.625 10.3824 13.625 7C13.625 3.61758 10.8824 0.875 7.5 0.875ZM7.5 12.0859C4.6918 12.0859 2.41406 9.8082 2.41406 7C2.41406 4.1918 4.6918 1.91406 7.5 1.91406C10.3082 1.91406 12.5859 4.1918 12.5859 7C12.5859 9.8082 10.3082 12.0859 7.5 12.0859Z",
    fill: "#031FEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.84354 4.59375C6.84354 4.7678 6.91268 4.93472 7.03575 5.05779C7.15882 5.18086 7.32574 5.25 7.49979 5.25C7.67383 5.25 7.84075 5.18086 7.96382 5.05779C8.0869 4.93472 8.15604 4.7678 8.15604 4.59375C8.15604 4.4197 8.0869 4.25278 7.96382 4.12971C7.84075 4.00664 7.67383 3.9375 7.49979 3.9375C7.32574 3.9375 7.15882 4.00664 7.03575 4.12971C6.91268 4.25278 6.84354 4.4197 6.84354 4.59375ZM7.82791 6.125H7.17166C7.11151 6.125 7.06229 6.17422 7.06229 6.23438V9.95312C7.06229 10.0133 7.11151 10.0625 7.17166 10.0625H7.82791C7.88807 10.0625 7.93729 10.0133 7.93729 9.95312V6.23438C7.93729 6.17422 7.88807 6.125 7.82791 6.125Z",
    fill: "#031FEF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfoCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/InfoCircle.fd3f203e.svg";
export { ForwardRef as ReactComponent };